export default __webpack_public_path__ + "static/media/640_business03-es-mobile.a43d9cad.png";